// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"664":"core_home","987":"popularize_pay"}[chunkId] || chunkId) + "." + {"265":"098780a1","664":"392559cf","987":"8941fff4"}[chunkId] + ".css";
};